module.exports = "../../static/fonts/Lato-Light.5b761f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-Light.ttf
// module id = 915
// module chunks = 2